<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_calendar"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                ACL Model <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>Model {{ model_name }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>
                    <main>
                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">
                                <div v-if="resource.acl">
                                    <acl-authorizations v-model="resource.acl" :model="model_name"></acl-authorizations>
                                </div>
                            </tab>
                        </tabs>
                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import AclModelService from './AclModelService.js';

    export default {
        data () {
            return {
                className: 'modal-fade-enter-active',
                profile: {},
                model_name: null,
                resource: {
                    acl: null,
                    model: null
                },
                permissions: [],
                existingPermission: []
            }
        },
        mounted: function(){

            let self = this;

            this.model_name = this.$route.params.model;
            setTimeout(function(){self.className = ""}, 100);

            AclModelService.get( this.model_name ).then( response => {
                self.resource = response.data;
            });

        },
        methods: {
            resourceLoaded: function(){
                this.localesLoaded = true;
            },
            getResource: function(){
                return AclModelService
            },
            back: function(id){
                let self = this;
                if( this.className == "" && !this.isModal ){
                    let name = self.$route.name.replace('-edit', '').replace('-new', '')
                    //name = self.$route.meta.parent ? self.$route.meta.parent : name
                    self.$router.push({name: name});
                }
                self.$emit('close');
            },
            submit: function(){
                this.resource._axioMessageSuccess = true;
                AclModelService.create(this.resource).then((response) => {
                    this.$router.push({name: 'acl', params: {id: response.data.id }});
                    this.$emit('refresh', this);
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/authorizations/Edit.vue